import { chakra } from "@chakra-ui/react";
import React, { ReactElement } from "react";
import LinkButton from "../LinkButton";
import InspectorItem from "./InspectorItem";

interface FeaturesSelectedCountProps {
  count: number;
  onClear: () => void;
}

export default function FeaturesSelectedCount(
  props: FeaturesSelectedCountProps
): ReactElement | null {
  const { count, onClear } = props;

  return count === 0 ? null : (
    <InspectorItem right={<LinkButton onClick={onClear}>Clear</LinkButton>}>
      <chakra.span color="gray.400">{count} features selected</chakra.span>
    </InspectorItem>
  );
}
